export type HelpLinks =
  | 'faq'
  | 'finish'
  | 'with_agent'
  | 'stop'
  | 'live_chat'
  | 'contract_copy'
  | 'helpline';
